import React, { useEffect, useState } from "react";
import { Chrono } from "react-chrono";
import { useTranslation } from "react-i18next";
import ScrollIcon from "./ScrollDown";
import aboutData from "../aboutus/about.json";
import one from "../aboutus/images/one.svg";
import two from "../aboutus/images/two.svg";
import three from "../aboutus/images/three.svg";
import four from "../aboutus/images/four.svg";
import five from "../aboutus/images/five.svg";
import six from "../aboutus/images/six.svg";
import seven from "../aboutus/images/seven.svg";
import eight from "../aboutus/images/eight.svg";
import nine from "../aboutus/images/nine.svg";
import ten from "../aboutus/images/ten.svg";
import eleven from "../aboutus/images/eleven.svg";
import tweleve from "../aboutus/images/tweleve.svg";
import thirteen from "../aboutus/images/thirteen.svg";
import fourteen from "../aboutus/images/fourteen.svg";
import fifteen from "../aboutus/images/fifteen.svg";
import sixteen from "../aboutus/images/sixteen.svg";

const timeLineImages = {
  one: one,
  two: two,
  three: three,
  four: four,
  five: five,
  six: six,
  seven: seven,
  eight: eight,
  nine: nine,
  ten: ten,
  eleven: eleven,
  tweleve: tweleve,
  thirteen: thirteen,
  fourteen: fourteen,
  fifteen: fifteen,
  sixteen: sixteen
}

const Timeline = () => {
  const { i18n, t } = useTranslation();
  const [timelineItems, setTimelineItems] = useState([]);
  const [renderKey, setRenderKey] = useState(Date.now());

  useEffect(() => {
    // const fetchTimelineData = async () => {
    //   try {
    //     const response = await fetch(
    //       "https://raw.githubusercontent.com/prasathvjkmr/kaigal-translation/main/about/about.json"
    //     );
    //     const data = await response.json();
    //     setTimelineItems(data);
    //     setRenderKey(Date.now());
    //   } catch (error) {
    //     console.error("Error fetching timeline data: ", error);
    //   }
    // };
    // fetchTimelineData();
    setTimelineItems(aboutData);
    setRenderKey(Date.now());
  }, [i18n.language, t]);

  // useEffect(() => {
  // }, [i18n.language, t]);

  return (
    <div
      key={renderKey}
      className="flex justify-center items-center"
      id="timeline"
    >
      <Chrono
          items={timelineItems.map((item) => ({
              title: t(item.title),
              cardTitle: t(item.cardTitle),
              cardSubtitle: item.link ? (
                  <div className="flex justify-end -mt-1">
                      <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`bg-white px-3 py-1 rounded-md text-sm font-medium shadow transition-colors ${item.id % 2 === 0
                              ? "text-[#2C2A7A] hover:bg-[#2C2A7A] hover:text-white"
                              : "text-[#EE6A29] hover:bg-[#EE6A29] hover:text-white"
                          }`}
                      >
                          {t(item.button_name)}
                      </a>
                  </div>

              ) : null,
          }))}
          mode="VERTICAL_ALTERNATING"
          showSingle
          slideItemDuration={2000}
          slideShow
          timelinePointDimension={50}
          fontSizes={{
            cardTitle: "1.25rem",
            title: "1.05rem",
          }}
          highlightCardsOnHover
          theme={{
            primary: "grey",
            secondary: "white",
            cardBgColor: "#EE6A29",
            cardForeColor: "violet",
            titleColor: "#2C2A7A",
            titleColorActive: "#EE6A29",
          }}
          cardHeight={85}
          hideControls={true}
      >
        <div className="chrono-icons">
          {timelineItems.map((img, index) => (
              <img
                  src={timeLineImages[`${img.image}`]}
                  key={index}
                  alt="Icon"
                  loading="lazy"
              />
          ))}
        </div>
      </Chrono>
      <ScrollIcon />
    </div>
  );
};

export default Timeline;
